import { speechTone, toneChipClass } from "@/lib/status-tone";
import { cn } from "@/lib/utils";

/**
 * Estimated speech time — DESIGN §17.11.6. Words (camelCase split) times a configured rate, not a
 * measurement, so it is printed with a "~" and coloured against the configured limit.
 */
export function SpeechChip({
  seconds,
  limit,
  className,
}: {
  seconds: number | null | undefined;
  limit: number;
  className?: string;
}) {
  if (seconds === null || seconds === undefined) return null;
  return (
    <span
      title={`About ${seconds.toFixed(1)}s to say aloud (limit ${limit.toFixed(1)}s) — an estimate from word count`}
      className={cn(
        "inline-block rounded px-1.5 py-0.5 font-mono text-[10.5px] font-medium whitespace-nowrap tabular-nums",
        toneChipClass(speechTone(seconds, limit)),
        className,
      )}
    >
      ~{seconds.toFixed(1)}s
    </span>
  );
}
